module.exports = __webpack_public_path__ + "static/media/nurse.67725940.jpg";